module.exports = __webpack_public_path__ + "static/img/celoscope-36.c847b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-36.jpg
// module id = N+VE
// module chunks = 52